var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.clientBalance && _vm.$i18n.locale === "cl"
    ? _c(
        "div",
        { staticClass: "wallet-card" },
        [
          _c(
            "b-tag",
            {
              attrs: {
                icon: "fa-solid fa-wallet",
                type: "is-primary",
                size: "is-medium",
                rounded: true,
              },
            },
            [
              _c("span", { staticClass: "main-text has-text-secondary" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("walletBalance")))]),
                _c("b", [
                  _vm._v(_vm._s(`$ ${_vm.formatNumber(_vm.clientBalance)}`)),
                ]),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }